<template>
  <div>
    <h3 class="title">{{ survey().survey_name }}</h3>
    <v-tabs v-model="currentTab" slider-color="primary" class="mb-3">
      <v-tab href="#survey">{{ $t('survey') }}</v-tab>
      <v-tab href="#survey_summary">{{ $t('survey_summary') }}</v-tab>
    </v-tabs>
    <component :is="currentView" />
  </div>
</template>

<script>
import Survey from './Survey/Survey.vue'
import SurveySummary from './SurveySummary/SurveySummary.vue'

export default {
  inject: ['survey'],
  data() {
    return {
      currentTab: 'survey'
    }
  },
  computed: {
    currentView() {
      return {
        survey: Survey,
        survey_summary: SurveySummary
      }[this.currentTab]
    }
  }
}
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/view/dashboard/survey/SurveyDetail.vue